import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navItems, PUBLIC_URL } from '../../data/constants';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  React.useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY && currentScrollY > 60) {
            setShowHeader(false); // scrolling down
          } else {
            setShowHeader(true); // scrolling up
          }
          setLastScrollY(currentScrollY);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [lastScrollY]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleNavigation = (href: string) => {
    setIsMenuOpen(false);
    if (href.startsWith('#')) {
      if (location.pathname === '/') {
        const element = document.querySelector(href);
        element?.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.location.href = '/' + href;
      }
    } else {
      scrollToTop();
    }
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark sticky-top"
      style={{
        background: '#000000',
        backgroundImage: 'linear-gradient(to right, #434343, #000000)',
        transition: 'transform 0.3s',
        transform: showHeader ? 'translateY(0)' : 'translateY(-100%)',
        zIndex: 1050
      }}
    >
      <div className="container position-relative py-2">
        <a
          className="navbar-brand d-flex align-items-center gap-2"
          href="/"
          style={{ marginLeft: '1px' }}
        >
          <img
            src={`${PUBLIC_URL}/images/logos/New-Dreamin-Logo-White.png`}
            alt="Bengaluru Dreamin Logo"
            style={{ height: '36px' }}
            className="d-inline-block align-text-top"
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {navItems.filter(item => item.id !== 'our-initiatives').map(item => (
              <li className="nav-item" key={item.id}>
                <Link
                  className="nav-link text-white nav-link-underline"
                  to={item.href}
                  onClick={() => handleNavigation(item.href)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
      
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;